<ul class="idp-tab__nav">
  <ng-container *ngFor="let tabItem of tabList; let i = index">
    <li class="idp-tab__nav-item">
      <a
        href="tabItem.url?tabItem.url:javascript:void(0);"
        [ngClass]="selectedTabIndex === i ? 'idp-tab__nav-item-btn-active' : ''"
        class="idp-tab__nav-item-btn"
        (click)="notifyTabSelection($event, tabItem, i)"
        [innerHtml]="tabItem?.tabDescription"
        [attr.data-cy]="'idp-tab-nav-' + i"
      ></a>
      <span
        aria-hidden="true"
        class="idp-tab__nav-item-separator"
        [attr.data-cy]="'idp-tab-nav-separator-' + i"
        *ngIf="i < tabList.length - 1"
      >
        |
      </span>
    </li>
  </ng-container>
</ul>
